import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsDelete.vue?vue&type=template&id=da091936&scoped=true&"
import script from "./MonthAllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da091936",
  null
  
)

export default component.exports